function assign_gift_message_btn() {
//  fixes aria-lable on gift message

  //console.log("ssssssssssssss"); 
  
  var z = document.getElementsByClassName("icart-new-lab-bor");
  var iii;
  for (iii = 0; iii < z.length; iii++) {

    if (z[iii].hasAttribute("data-key")) {
       z[iii].setAttribute("aria-label", "enter gift message below"); // updates aria-lable
       z[iii].setAttribute("aria-hidden", "true"); // updates aria-lable
      // z[iii].setAttribute("aria-selected", "false"); // updates aria-lable
      
   //   z[iii].setAttribute("title", "activate to show enlarged image"); // adds H2 to the main menu items
}  // end if

    

  }
} // end function


function assign_product_img_instructions() {
//  This assigns more instructions to product images on product page - CM

  var x = document.getElementsByClassName("pwzrjss5");
  var i;
  for (i = 0; i < x.length; i++) {
 
    if (x[i].hasAttribute("role")) {
       x[i].setAttribute("id", "product_image_id" + i); // adds H2 to the main menu items 
      x[i].setAttribute("title", "activate to show enlarged image"); // adds H2 to the main menu items
}  // end if


   

  }
} // end function

function assign_product_img_instructions_img() {
//  This assigns more instructions to product images on product page - CM


    var xx = document.getElementsByClassName("pwzrjss3");
  var ii;
  for (ii = 0; ii < xx.length; ii++) {
 
    if (xx[ii].hasAttribute("src")) {
      xx[ii].setAttribute("aria-labelledby", "product_image_id" + ii); // adds H2 to the main menu items
}  // end if

    


    

  }
} // end function




function assign_headers_to_nav() {
// This assigns instructions to header items that are collapsable like  main nav item  Shop, about Safety - CM

  
 //  console.log("yyyyyyyyyyyyyyyyyyyyyy"); 

  
  var x = document.getElementsByClassName("header__menu-item");
  var i;
  for (i = 0; i < x.length; i++) {
 //   console.log(x[i]);
 //  console.log("88888888888888888"); 
    
    // x[i].setAttribute("role", "heading");  // adds H2 to the main menu items


    if (x[i].hasAttribute("aria-expanded")) {
 // element.setAttribute("target", "_self");

      
           x[i].setAttribute("aria-label", "to activate press enter"); // adds H2 to the main menu items
    
  //  x[i].setAttribute("aria-required", "true");
}  // end if

    

  }
} // end function



document.addEventListener("DOMContentLoaded", function() {
    // code here 
  
  //assign_headers_to_nav(); 

  // Delays the function so nav can load, better andcorrect way is to wait for qikify's function. They said: You can listen for the event "smartmenu-loaded". - CM
  setTimeout(assign_headers_to_nav, 3000);
  setTimeout(assign_product_img_instructions, 3000);
  setTimeout(assign_product_img_instructions_img, 3000);
setTimeout(assign_gift_message_btn, 3000);
  
  });
 




// Start - Press enter to assign aria info on nav //

$( document ).ready(function() {
    console.log( "ready!" );


  $(".link--text focus-inset").keypress(function(){
     console.log("dddddddddddddddddddddd"); 
  
  //$("span").text(i += 1);
});


 
});  // end onready()




// End - Press enter to assign aria info on nav //


